import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';

interface Props {
  label: string;
  initialDate: Date;
  onDateChange: (date: Date) => void;
  disabled: boolean;
}

const BasicDateTimePicker: React.FC<Props> = ({
  label,
  initialDate,
  onDateChange,
  disabled,
}): React.ReactElement => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        renderInput={(props: any) => <TextField {...props} />}
        label={label}
        value={initialDate}
        disabled={disabled}
        onChange={(newValue: any) => {
          let newDate: Date = newValue ?? new Date();
          onDateChange(newDate);
        }}
      />
    </LocalizationProvider>
  );
};

export default BasicDateTimePicker;
